import i18n from "../../../i18n.js";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import logo_white from "../../assets/images/logo_white.png";
import nextOctoberLogo from "../../assets/images/next-october-logo-v2.png";
import { Link, useLocation } from "react-router-dom";
import Utility from "../../utility";
import Button from "../../../utility/components/Button";
import { withNamespaces } from "react-i18next";
import Select from "react-select";
import {
  increaseFontSize,
  decreaseFontSize,
  setFontSize,
} from "../../../actions/allActions.js";
import { isPublicNewsEnabled } from "../../publicNewsFeature";

const Header = (props) => {
  const {
    t,
    increaseFontSize,
    decreaseFontSize,
    setFontSize,
    fontSize,
    themeDisable,
    themeEnable,
    siteSettings = {},
  } = props;
  const handleIncreaseFontSize = () => {
    if (fontSize < 8) {
      increaseFontSize();
    }
  };

  const handleDecreaseFontSize = () => {
    if (fontSize > -8) {
      decreaseFontSize();
    }
  };
  const resetFontSize = () => {
    setFontSize();
    window.location.reload();
  };
  const options = [
    { value: "en", label: "EN" },
    { value: "he", label: "HEB" },
  ];
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage");
    return storedLanguage
      ? JSON.parse(storedLanguage)
      : { value: "en", label: "EN" };
  });

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage.value);
  }, [selectedLanguage]);

  // useEffect(() => {
  //   const fetchPricingSettings = async () => {
  //     try {
  //       const response = await fetch("http://144.126.254.60:5000/api/site-settings/pricing")
  //       const data = await response.json()
  //       if (data.success && data.data.value == true) {
  //         setShowPricing(true)
  //       } else {
  //         setShowPricing(false)
  //       }
  //     } catch (error) {
  //       console.log("Pricing fetching error", error);
  //       showPricing(false)
  //     }
  //   }
  //   fetchPricingSettings()
  // }, [])
  const showPricing = siteSettings['pricing-admin-setting']?.value === '1';

  const handleChange = (selectedOption) => {
    setSelectedLanguage(selectedOption);
    localStorage.setItem("selectedLanguage", JSON.stringify(selectedOption));
  };
  const [activeLink, setActiveLink] = useState("");
  const handleLinkClick = (link) => {
    setActiveLink(link);
  };
  const location = useLocation();
  useEffect(() => {
    // Close all notifications when route changes
    Utility.closeAllNotifications();
    setActiveLink(location.pathname);
  }, [location.pathname]);
  const [expanded, setExpanded] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [memorialsMenuOpen, setMemorialsMenuOpen] = useState(false);
  const memorialsDropdownRef = useRef(null);
  const handleToggle = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMemorialsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        memorialsDropdownRef.current &&
        !memorialsDropdownRef.current.contains(event.target)
      ) {
        setMemorialsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isDesktopNav = () =>
    window.matchMedia("(min-width: 992px)").matches;

  const handleMemorialsMouseEnter = () => {
    if (isDesktopNav()) {
      setMemorialsMenuOpen(true);
    }
  };

  const handleMemorialsMouseLeave = () => {
    if (isDesktopNav()) {
      setMemorialsMenuOpen(false);
    }
  };

  const handleMemorialsToggleClick = () => {
    if (!isDesktopNav()) {
      setMemorialsMenuOpen((open) => !open);
    }
  };

  return (
    <>
      <header className={`header_wrapper${isScrolled ? " is-scrolled" : ""}`}>
        <div className="container hdr_container">
          <Link className="navbar-brand logo" to="/">
            <img src={logo_white} alt="" />
          </Link>
          <nav className="navbar navbar-expand-lg nav_menu">
            <Button
              className={`${expanded ? "navbar-toggler" : "navbar-toggler collapsed"
                }`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navHeader"
              aria-controls="navHeader"
              aria-expanded={`${expanded ? "true" : "false"}`}
              aria-label="Toggle navigation"
              onClick={handleToggle}
            >
              <i className="fa-solid fa-bars"></i>
            </Button>
            <div
              className={`${expanded
                  ? "collapse navbar-collapse show"
                  : "collapse navbar-collapse"
                }`}
              id="navHeader"
            >
              <ul className="navbar-nav navbar-left">
                <li
                  className={
                    activeLink === "/" ? "nav-item active" : "nav-item"
                  }
                  onClick={() => handleLinkClick("/")}
                >
                  <Link className={`nav-link ${i18n.language=="he"? "":""}`}to="/" onClick={handleToggle}>
                    {t("headerHomeLink")}
                  </Link>
                </li>
                <li
                  className={
                    activeLink === "/aboutUs" ? "nav-item active" : "nav-item"
                  }
                  onClick={() => handleLinkClick("/aboutUs")}
                >
                  <Link
                    className="nav-link"
                    to="/aboutUs"
                    onClick={handleToggle}
                  >
                    {t("headerAboutUsLink")}
                  </Link>
                </li>
                <li
                  className={
                    activeLink === "/ourTeam" ? "nav-item active" : "nav-item"
                  }
                  onClick={() => handleLinkClick("/ourTeam")}
                >
                  <Link
                    className="nav-link"
                    to="/ourTeam"
                    onClick={handleToggle}
                  >
                    {t("headerOurTeamLink")}
                  </Link>
                </li>
                {isPublicNewsEnabled ? (
                  <li
                    className={
                      activeLink === "/latestnews"
                        ? "nav-item active"
                        : "nav-item"
                    }
                    onClick={() => handleLinkClick("/latestnews")}
                  >
                    <Link
                      className="nav-link"
                      to="/latestnews"
                      onClick={handleToggle}
                    >
                      {t("headerNewsLink")}
                    </Link>
                  </li>
                ) : null}
                <li
                  ref={memorialsDropdownRef}
                  className={`nav-item nav-item--memorials-dropdown${
                    activeLink === "/memorials" ||
                    activeLink === "/memorials/battalion-28"
                      ? " active"
                      : ""
                  }${memorialsMenuOpen ? " show" : ""}`}
                  onMouseEnter={handleMemorialsMouseEnter}
                  onMouseLeave={handleMemorialsMouseLeave}
                >
                  <div className="header_memorials_nav_group">
                    <button
                      type="button"
                      className="nav-link header_memorials_dropdown_toggle"
                      aria-expanded={memorialsMenuOpen}
                      aria-haspopup="true"
                      onClick={handleMemorialsToggleClick}
                    >
                      {t("headerMemorialsLink")}
                    </button>
                    <a
                      className="header_next_october_link"
                      href="https://www.nextoctober.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={t("headerNextOctoberAriaLabel")}
                      onClick={handleToggle}
                    >
                      <img
                        src={nextOctoberLogo}
                        alt=""
                        className="header_next_october_logo"
                      />
                    </a>
                  </div>
                  <div
                    className={`header_memorials_dropdown_menu${
                      memorialsMenuOpen ? " show" : ""
                    }`}
                  >
                    <div className="header_memorials_dropdown_yedidya_row">
                      <Link
                        className="header_memorials_dropdown_item"
                        to="/memorials"
                        onClick={() => {
                          handleLinkClick("/memorials");
                          setMemorialsMenuOpen(false);
                          handleToggle();
                        }}
                      >
                        {t("headerMemorialsYedidyaLink")}
                      </Link>
                      <a
                        className="header_memorials_dropdown_item header_memorials_dropdown_item--next-october"
                        href="https://www.nextoctober.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={t("headerNextOctoberAriaLabel")}
                        onClick={() => {
                          setMemorialsMenuOpen(false);
                          handleToggle();
                        }}
                      >
                        <img
                          src={nextOctoberLogo}
                          alt=""
                          className="header_memorials_dropdown_logo"
                        />
                      </a>
                    </div>
                    <Link
                      className="header_memorials_dropdown_item header_memorials_dropdown_item--battalion"
                      to="/memorials/battalion-28"
                      onClick={() => {
                        handleLinkClick("/memorials/battalion-28");
                        setMemorialsMenuOpen(false);
                        handleToggle();
                      }}
                    >
                      {t("headerMemorialsBattalion28Link")}
                    </Link>
                  </div>
                </li>
                {/* <li
                  className={
                    activeLink === "/subscriptions"
                      ? "nav-item active"
                      : "nav-item"
                  }
                  onClick={() => handleLinkClick("/subscriptions")}
                >
                  <Link
                    className="nav-link"
                    to="/subscriptions"
                    onClick={handleToggle}
                  >
                    {t("headerPricingLink")}
                  </Link>
                </li> */}
                {showPricing && (
                  <li className={activeLink === "/subscriptions" ? "nav-item active" : "nav-item"} onClick={() => handleLinkClick("/subscriptions")}>
                    <Link className="nav-link" to="/subscriptions" onClick={handleToggle}>
                      {t("headerPricingLink")}
                    </Link>
                  </li>
                )}
                <li
                  className={
                    activeLink === "/contactUs" ? "nav-item active" : "nav-item"
                  }
                  onClick={() => handleLinkClick("/contactUs")}
                >
                  <Link
                    className="nav-link"
                    to="/contactUs"
                    onClick={handleToggle}
                  >
                    {t("headerContactUsLink")}
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
          <div className="header_log_in">
            <ul>
              <li>
                <Link to="/login">
                  <span>
                    <i className="fa-solid fa-arrow-right-to-bracket"></i>
                  </span>
                  {t("headerLoginLink")}
                </Link>
              </li>
              <li className="language_dropDown">
                <Select
                  options={options}
                  value={selectedLanguage}
                  onChange={handleChange}
                  placeholder={"EN"}
                />
              </li>
              {/* <li>
                <div className="accessibility">
                  <em>
                    <i className="fa-solid fa-universal-access"></i>
                  </em>
                  <div className="accessibility_dropdown">
                    <ul>
                      <li>
                        <Button onClick={handleIncreaseFontSize}><i className="fa-solid fa-magnifying-glass-plus"></i><span>Increase Text</span></Button>
                      </li>
                      <li>
                        <Button onClick={handleDecreaseFontSize}><i className="fa-solid fa-magnifying-glass-minus"></i><span>Decrease Text</span></Button>
                      </li>
                      <li>
                        <Button onClick={themeEnable}><i className="fa-solid fa-magnifying-glass-minus"></i><span>Theme</span></Button>
                      </li>
                      <li>
                        <Button onClick={() => { resetFontSize(); themeDisable() }}><i className="fa-solid fa-rotate-left"></i><span>Reset</span></Button>
                      </li>
                    </ul>
                  </div>
                </div>
              </li> */}
            </ul>
          </div>
        </div>
      </header>
    </>
  );
};
const mapStateToProps = (globalState) => {
  return {
    userData: globalState.mainReducerData.userData,
    fontSize: globalState.mainReducerData.fontSize,
  };
};
export default connect(mapStateToProps, {
  increaseFontSize,
  decreaseFontSize,
  setFontSize,
})(withNamespaces()(Header));
